<template>
    <a-modal v-model="visible" :width="600" :title="`${title} (必填)`" :confirm-loading="sumbitLoading" :after-close="afterClose" @ok="handleOk">
        <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="站点编码" prop="stationCode">
                        <a-input v-model="form.stationCode" placeholder="请输入站点编码" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="站点ID" prop="stationId">
                        <a-input v-model="form.stationId" placeholder="请输入站点ID" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="站点名称" prop="stationName">
                        <a-input v-model="form.stationName" placeholder="请输入站点名称" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="位置信息" prop="stationLoc">
                        <a-cascader v-model="form.stationLoc" :field-names="fieldNames" :options="cityOptions" :show-search="{ filter }" placeholder="请选择位置信息" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-form-model-item label="站点地址" prop="stationAddress">
                        <a-input v-model="form.stationAddress" placeholder="请输入站点详细地址" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>

<script>
import { insertStation, updateStation, cityAreaTree } from '../../api';

export default {
    name: 'EditStationDialog',
    data() {
        return {
            visible: false,
            title: '新增站点',
            form: {},
            rules: {
                stationCode: [{ required: true, message: '请输入站点编码', trigger: 'change' }],
                stationId: [{ required: true, message: '请输入站点ID', trigger: 'change' }],
                stationName: [{ required: true, message: '请输入站点名称', trigger: 'change' }],
                stationLoc: [{ required: true, message: '请选择位置信息', trigger: 'change' }],
                stationAddress: [{ required: true, message: '请输入站点详细地址', trigger: 'change' }]
            },
            cityOptions: [],
            fieldNames: {
                label: 'areaName',
                value: 'areaName',
                children: 'children'
            },
            sumbitLoading: false,
            isEdit: false
        };
    },
    created() {
        this.getCityAreaTree();
    },
    methods: {
        show(item) {
            if (item) {
                this.form = { ...item, oldStationId: item.stationId, stationLoc: item.stationLoc ? item.stationLoc.split('-') : '' };
            }
            this.isEdit = !!item;
            this.title = item ? '编辑站点' : '新增站点';
            this.visible = true;
        },
        async getCityAreaTree() {
            const res = await cityAreaTree({
                filterBlackList: true,
                grades: ['PROVINCE', 'CITY', 'COUNTY']
            });
            this.cityOptions = this.disposeData(res);
        },
        disposeData(data) {
            return data.map((item) => {
                if (item.children && item.children.length) {
                    const children = this.disposeData(item.children);
                    return { ...item, children };
                }
                const { children, ...restParams } = item;
                return { ...restParams };
            });
        },
        onclose() {
            this.visible = false;
        },
        filter(inputValue, path) {
            return path.some((option) => option.areaName.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        async handleOk() {
            await this.$refs.form.validate();
            this.sumbitLoading = true;
            const { stationLoc, ...restParams } = this.form;
            const data = {
                ...restParams,
                customerCode: this.$store.state.user.tenantId,
                stationLoc: stationLoc.join('-')
            };
            try {
                if (this.isEdit) {
                    await updateStation({ ...data });
                    this.$message.success('修改成功');
                } else {
                    await insertStation({ ...data });
                    this.$message.success('新增成功');
                }
                this.onclose();
                this.$emit('refresh');
                this.sumbitLoading = false;
            } catch (error) {
                this.sumbitLoading = false;
            }
        },
        afterClose() {
            this.$refs.form.clearValidate();
            this.form = {};
        }
    }
};
</script>

<style lang="less" scoped>
.ant-form {
    /deep/.ant-form-item-required::before {
        display: none;
    }
}
</style>
